import { Calendar } from 'vanilla-calendar-pro'
import 'vanilla-calendar-pro/styles/index.css'

export const initVanillaCalendar = (inputElement, calendarContainerId, initDateRange = null, onRangeConfirm = null) => {

  const calendar = new Calendar(inputElement, {
    inputElement: inputElement, // 明確指定 input dom
    element:  `#${calendarContainerId}`,  // 指定 calendar 要畫在哪個 DOM 裡
    inputMode: true, // 點 input 才顯示日曆
    type: 'multiple', // 必須配合 selectionDatesMode 才能選 range
    selectionDatesMode: 'multiple-ranged', // 選一段區間
    enableEdgeDatesOnly: false, // 回傳完整區間（不是只有起訖）
    selectedDates: initDateRange ? initDateRange.split(' ~ ') : [],

    // 當選日期時自動判斷範圍長度
    onClickDate(self) {
      const selected = self.context.selectedDates;
      // 判斷：selected 至少兩個，且兩個都是日期字串（YYYY-MM-DD）
      const isValidRange = selected.length >= 2 && selected.every((d) => /^\d{4}-\d{2}-\d{2}$/.test(d));
    
      if (isValidRange) {
        self.hide();
      }
    },
    // onHide 用來寫入 input
    onHide(self) {
      const el = self.context.inputElement;
      const dates = self.context.selectedDates;
      if (!el || !dates) return;

      const isValidRange = dates.length >= 2 && 
        dates.every(d => /^\d{4}-\d{2}-\d{2}$/.test(d));
  
      if (isValidRange) {
        const [start, end] = [dates[0], dates[dates.length - 1]];
        el.value = `${start} ~ ${end}`;
        if (onRangeConfirm) onRangeConfirm({ start, end });
      }
    }
  });

  calendar.init();
  return calendar;
};
